import {ReactNode} from 'react';
import {cn, DEVICE, useScreenResize} from '@chekin/guestapp-ui-kit';
import {useLayoutMode} from 'hooks/useLayoutMode';
import {Navbar as MobileNavbar} from './Components/Navbar';
import {Footer} from './Components/Footer';
import {PageWrapper, Wrapper} from './styled';

type PageUniversalLinkProps = {
  children: ReactNode;
  className?: string;
};

function PageUniversalLink({children, className}: PageUniversalLinkProps) {
  const {isMatch: isMobile} = useScreenResize(DEVICE.laptop);
  const layoutMode = useLayoutMode();
  const showMobileNavbar = isMobile || layoutMode === 'kiosko';

  return (
    <PageWrapper className="kiosko:h-[calc(100%-150px)]">
      {showMobileNavbar && <MobileNavbar />}
      {/* TODO refactor this whole implementation implementing this component on a higher level */}
      <Wrapper className={cn('page_content', 'kiosko:px-[94px]', className)}>
        {children}
      </Wrapper>
      {layoutMode === 'default' && <Footer />}
    </PageWrapper>
  );
}

export {PageUniversalLink};
